type Adjustment = { total: number | string; petunjuk?: string }

// Amounts arrive as raw decimal numbers/strings, never formatted display text.
const cents = (value: number | string) => Math.round((Number(value) + Number.EPSILON) * 100)

export function reconcileInvoice(grTotal: number, tagihan: number | string, additions: Adjustment[], deductions: Adjustment[]) {
    const additionCents = additions.reduce((sum, row) => sum + Math.abs(cents(row.total)), 0)
    const deductionCents = deductions.reduce((sum, row) => sum + Math.abs(cents(row.total)), 0)
    const expectedCents = cents(grTotal) + additionCents - deductionCents
    const differenceCents = cents(tagihan) - expectedCents
    const isAddition = differenceCents > 0
    const label = isAddition ? 'SALAH HARGA (+)' : 'SALAH HARGA (-)'
    const target = (isAddition ? additions : deductions).find(row => row.petunjuk === label)
    const currentCents = Math.abs(cents(target?.total ?? 0))
    return {
        expected: expectedCents / 100,
        addition: additionCents / 100,
        deduction: deductionCents / 100,
        difference: differenceCents / 100,
        isValid: Number.isFinite(differenceCents) && Math.abs(differenceCents) <= 1,
        section: isAddition ? 'Penambahan Tagihan' : 'Pengurangan Tagihan',
        anchor: isAddition ? 'penambahan-tagihan' : 'pengurangan-tagihan',
        label,
        current: currentCents / 100,
        suggested: (currentCents + Math.abs(differenceCents)) / 100,
    }
}
